import addDays from 'date-fns/addDays'

const daysWeek = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
]

const addDaysName = (days: number) => {
  const date = addDays(new Date(), days)
  return {
    value: date,
    name: days === 0 ? 'Today' : daysWeek[date.getDay()]
  }
}

const getWeekDates = () => {
  const r: {
    value: Date | string
    name: string
  }[] = daysWeek.map((_, i) => addDaysName(i))
  r.unshift({
    value: '',
    name: 'This week'
  })
  return r
}

export default getWeekDates
